import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TRANSLATIONS } from './translations';

@Injectable({ providedIn: 'root' })
export class TranslateService {
  private lang$ = new BehaviorSubject<'en'|'it'>('en');

  setLang(l: 'en'|'it'){
    console.debug('[TranslateService] setLang', l);
    this.lang$.next(l);
  }

  // expose observable for subscribers
  getLang$() {
    return this.lang$.asObservable();
  }

  getLang(){
    return this.lang$.value;
  }

  // simple sync translate
  t(key: string): string {
    const l = this.getLang();
    const val = TRANSLATIONS[l] && TRANSLATIONS[l][key] ? TRANSLATIONS[l][key] : key;
    // debug to help verify dynamic translation
    // console.debug('[TranslateService] t', key, '->', val, 'lang=', l);
    return val;
  }
}
